export default __webpack_public_path__ + "static/media/firebase-google.c02f8d50.png";